import { IScripShareholdingPatternApi } from "../types/scrip-shareholding-pattern-types.types";
import { API_PATHS } from "../constants/api-paths";
import { request } from "../core/api.client";

export const getScripScripShareholdingPattern = async (exchId: string, formattedSymbol: string) => {
  const response: {
    data: IScripShareholdingPatternApi;
    statusCode?: number;
    status?: string;
    message?: string;
  } = await request({
    method: "GET",
    url: `${API_PATHS.scripShareholdingPattern}?exchId=${exchId}&formattedSymbol=${formattedSymbol}`,
  });

  const updatedResponse = {
    data: { shpdata: response.data },
    statusCode: response.statusCode,
    status: response.status,
    message: response.message,
  };
  return updatedResponse;
};
